import { z } from 'zod';
import {} from "./companies.dto.js";
// Request and response schemas for the API layer
export const FindCompanyByIdRequestDTOSchema = z.object({
    params: z.object({
        companyId: z.string().uuid(),
    }),
});
//# sourceMappingURL=find-company-by-id.dto.js.map